var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-banner", style: _vm.cssVars }, [
    _vm.bannerData && _vm.bannerData.length > 0
      ? _c("div", { staticClass: "mobile-banner__swiper" }, [
          _c(
            "div",
            {
              staticClass: "mobile-banner__track",
              style: {
                transform: "translateX(-" + _vm.currentIndex * 100 + "%)",
              },
              on: {
                touchstart: _vm.onTouchStart,
                touchmove: _vm.onTouchMove,
                touchend: _vm.onTouchEnd,
              },
            },
            _vm._l(_vm.bannerData, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "mobile-banner__slide" },
                [
                  item.linkUrl
                    ? _c(
                        "a",
                        {
                          staticClass: "mobile-banner__link",
                          attrs: { href: item.linkUrl },
                        },
                        [
                          _c("img", {
                            staticClass: "mobile-banner__img",
                            attrs: {
                              src: item.imageUrl,
                              title: item.title,
                              alt: "",
                            },
                          }),
                        ]
                      )
                    : _c("div", { staticClass: "mobile-banner__link" }, [
                        _c("img", {
                          staticClass: "mobile-banner__img",
                          attrs: {
                            src: item.imageUrl,
                            title: item.title,
                            alt: "",
                          },
                        }),
                      ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.bannerData.length > 1
            ? _c(
                "div",
                { staticClass: "mobile-banner__dots" },
                _vm._l(_vm.bannerData, function (item, index) {
                  return _c("span", {
                    key: index,
                    staticClass: "mobile-banner__dot",
                    class: { "is-active": index === _vm.currentIndex },
                    on: {
                      click: function ($event) {
                        return _vm.goTo(index)
                      },
                    },
                  })
                }),
                0
              )
            : _vm._e(),
        ])
      : _c("div", { staticClass: "mobile-banner__placeholder" }, [
          _c("div", { staticClass: "mobile-banner__placeholder-text" }, [
            _vm._v("加载中..."),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }